import { render, staticRenderFns } from "./about_lanzhou.vue?vue&type=template&id=5b09ed6f&"
import script from "./about_lanzhou.vue?vue&type=script&lang=js&"
export * from "./about_lanzhou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports